import { useQuery, useQueryClient } from "@tanstack/react-query";
import { get } from "./api";

/** Lecture d'une ressource de l'API ; la clé de cache est le chemin. `null` désactive la requête. */
export function useGet<T = any>(path: string | null, opts: { refetchInterval?: number } = {}) {
  return useQuery({ queryKey: [path], queryFn: () => get<T>(path!), enabled: !!path, refetchInterval: opts.refetchInterval });
}

/** Invalide toutes les requêtes dont le chemin commence par l'un des préfixes donnés. */
export function useInvalidate() {
  const qc = useQueryClient();
  return (...prefixes: string[]) =>
    qc.invalidateQueries({
      predicate: (q) => typeof q.queryKey[0] === "string" && prefixes.some((p) => (q.queryKey[0] as string).startsWith(p)),
    });
}
